import { factory } from "./mocks/factory";

export * from "./types/Annotation";
export * from "./types/Assignment";
export * from "./types/AuditInformation";
export * from "./types/Booking";
export * from "./types/CheckinSessionState";
export * from "./types/ImmutableScan";
export * from "./types/JournalNoteItem";
export * from "./types/Measurement";
export * from "./types/Patient";
export * from "./types/Recording";
export * from "./types/Room";
export * from "./types/Site";
export * from "./types/SkinBookTracking";
export * from "./types/User";
export * from "./types/Visit";
export * from "./types/VisitSummary";

export * as fromAPI from "./adapter/fromAPI";

export const mock = {
  factory,
};
